import { BoardTheme } from "../@types/app.types";
import { BoardGridTheme } from "../components/Board/Board";
import {
  BoardHeaderFooterElement,
  makePieceSetDesignConfig,
} from "../contexts/studio/studioDesign.contextPartial";
import { MSG } from "../lang/MSG.enum";
import { ColorPalette } from "../utils/colors.utils";

const BoardThemeTikHianWhite: BoardTheme = {
  identifier: "tikhian-white",
  name: MSG.themeNameTikHianWhite,
  value: {
    board: {
      backgroundColor: "#FFFFFF",
      borderWidth: 0,
      borderRadius: 0,
      textColor: ColorPalette.inkBlue,
      borderColor: "#FFFFFF",
      fontSize: 48,
      fontFamily: "genwan",
      fontWeight: 600,
      inset: {
        userDefined: {
          top: 50,
          left: 50,
          right: 50,
          bottom: 150,
        },
      },
    },
    header: {
      distanceToBoardContent: 30,
      middle: {
        element: BoardHeaderFooterElement.None,
      },
    },
    footer: {
      distanceToBoardContent: 62,
      middle: {
        element: BoardHeaderFooterElement.LogoPZ,
      },
    },
    grid: {
      theme: "default" as BoardGridTheme,
      color: ColorPalette.black,
      opacity: 0.45,
    },
    columnNumberLabels: {
      enabled: true,
      red: {
        fontSize: 36,
        fontWeight: 600,
      },
      black: {
        fontSize: 36,
        fontWeight: 500,
      },
    },
    red: {
      ...makePieceSetDesignConfig("red"),
      charSet: "TikHianOriginal",
      fillColor: "#FFFFFF",
      textColor: "#D72809",
      outlineColor: "#D72809",
    },
    black: {
      ...makePieceSetDesignConfig("black"),
      charSet: "TikHianOriginal",
      fillColor: "#FFFFFF",
    },
    pieceSet: {
      charSet: "TikHianOriginal",
      charSetVariantDefs: {
        ba1: "A",
        ba2: "B",
        be1: "A",
        be2: "B",
        bh1: "A",
        bh2: "B",
        br1: "A",
        br2: "B",
        bc1: "A",
        bc2: "B",
        bs1: "A",
        bs2: "B",
        bs3: "C",
        bs4: "D",
        bs5: "E",

        ra1: "A",
        ra2: "B",
        re1: "A",
        re2: "B",
        rh1: "A",
        rh2: "B",
        rr1: "A",
        rr2: "B",
        rc1: "A",
        rc2: "B",
        rs1: "A",
        rs2: "B",
        rs3: "C",
        rs4: "D",
        rs5: "E",
      },
    },
  },
};

export default BoardThemeTikHianWhite;
